import { render, staticRenderFns } from "./FractionalDepositFeatureSettings.vue?vue&type=template&id=55c77d47"
import script from "./FractionalDepositFeatureSettings.vue?vue&type=script&lang=js"
export * from "./FractionalDepositFeatureSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55c77d47')) {
      api.createRecord('55c77d47', component.options)
    } else {
      api.reload('55c77d47', component.options)
    }
    module.hot.accept("./FractionalDepositFeatureSettings.vue?vue&type=template&id=55c77d47", function () {
      api.rerender('55c77d47', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MainContent/FractionalDepositFeatureSettings.vue"
export default component.exports